import { Link } from "react-router-dom";

export default function Logo({ size = "h-10" }) {
  return (
    <Link data-testid="logo-link-home" to="/" className="flex items-center gap-3 group">
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="Oxygen Gym — Fitness & Gym logo"
        className={`${size} w-auto rounded-full ring-1 ring-white/10 group-hover:ring-gold/60 transition-all duration-300`}
      />
      <span className="hidden sm:block font-display uppercase tracking-wide text-lg leading-none">
        Oxygen <span className="text-gold-gradient">Gym</span>
        <span className="block font-mono text-[9px] tracking-[0.3em] text-white/50 mt-1">FITNESS & GYM</span>
      </span>
    </Link>
  );
}
